export default {
    "changelog.title": "What's New",
    "changelog.seo_description": "Discover the latest features, improvements, and fixes brought to CitoyenPro.",
    "changelog.hero.title": "Update History",
    "changelog.hero.subtitle": "Discover the latest updates, improvements, and fixes brought to CitoyenPro.",
    "changelog.nav.back_home": "Back to Home",

    "changelog.updates.v130.title": "Internationalization (Bilingual)",
    "changelog.updates.v130.date": "February 8, 2026",
    "changelog.updates.v130.change1": "Full support for English and French",
    "changelog.updates.v130.change2": "Translated all questions (Quiz, True/False, Exams)",
    "changelog.updates.v130.change3": "Updated UI and transactional emails",
    "changelog.updates.v130.change4": "Language switcher with flags",

    "changelog.updates.v120.title": "Premium Subscription Launch",
    "changelog.updates.v120.date": "January 23, 2026",
    "changelog.updates.v120.change1": "New complete subscription system (Standard & Premium)",
    "changelog.updates.v120.change2": "Added timed mock exams",
    "changelog.updates.v120.change3": "Redesigned dashboard for better tracking",
    "changelog.updates.v120.change4": "Secure Stripe payment integration",

    "changelog.updates.v110.title": "Mobile Experience Enhancement",
    "changelog.updates.v110.date": "January 10, 2026",
    "changelog.updates.v110.change1": "Fully responsive interface for mobile and tablet",
    "changelog.updates.v110.change2": "Optimized dark mode to reduce eye strain",
    "changelog.updates.v110.change3": "New lateral navigation bar on Desktop",

    "changelog.updates.v100.title": "Official Launch of CitoyenPro",
    "changelog.updates.v100.date": "January 1, 2026",
    "changelog.updates.v100.change1": "Over 2000 questions based on the official guide",
    "changelog.updates.v100.change2": "Spaced repetition system for flashcards",
    "changelog.updates.v100.change3": "Secure email authentication",
    "changelog.updates.v100.change4": "Intelligent preparation score"
};
